var map = {
	"./business-360-1.png": "a203",
	"./business-valuation-1.png": "cdd8",
	"./carbon-footptint-1.png": "1e1e",
	"./cash-managment-1.png": "824b",
	"./credit-score-managment-1.png": "800f",
	"./smb-funding-1.png": "216d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4bc0";